/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { NavLink } from "react-router-dom";
import SearchableContent from "../../Layout/SearchableContent";
import {
  PaginationProduct,
  Product,
  useFilterProductsLazyQuery,
} from "../../generated/graphql";
import useDebounce from "../../hooks/useDebounce";
import useInputSearch from "../../hooks/useInputSearch";
import { useAppDispatch, useAppSelector } from "../../hooks/usereduxHooks";
import { ProductActionSuccess } from "../../store/actionCreator/product.creator";
import SearchPlaces from "../../utils/SearchPlaces";
import { formattedNum, limitAllItem } from "../../utils/constant";
import { HeadingKeyType } from "../itemSetup/ItemSetup";
import PrintButton from "../printButton/PrintButton";

const ProductTableHeading: HeadingKeyType = {
  "Item Code": { align: "left" },
  "Item Name": { align: "left" },
  "Pcs/bundle": { align: "right" },
  "Meter/Suits": { align: "right" },
  Rate: { align: "right" },
  Amount: { align: "right" },
};

export const selectOptionsForItems = [
  {
    name: "Item Code",
    value: "itemCode",
  },
  {
    name: "Item Name",
    value: "name",
  },
];
export function ItemStock() {
  const [page] = useState(0);
  const [limit] = useState(limitAllItem);

  const [searchKey, setSearchKey] = useState("name");

  const [search, setSearch] = useState("");

  const dispatch = useAppDispatch();
  const { products } = useAppSelector((store) => store.items);
  const [fetchProduct, { loading }] = useFilterProductsLazyQuery();

  // const [products, setProducts] = useState<PaginationProduct | undefined>(
  //   undefined,
  // );

  const fetchItems = async (orderKey?: string) => {
    const { data } = await fetchProduct({
      variables: {
        findMatchProductInput: {
          page: undefined,
          limit,
          name: search ? search?.trim() : "",
          searchKey: orderKey ?? searchKey,
        },
      },
      fetchPolicy: "no-cache",
    });

    dispatch(ProductActionSuccess(data?.filterProducts as PaginationProduct));
    if (orderKey) {
      toast.success("Sorting completed", { duration: 2000 });
    }
  };
  useEffect(() => {
    if (products?.items?.length) {
      return;
    }

    fetchItems();
  }, []);

  useDebounce(() => fetchItems(), 300, [search, searchKey, page, limit]);

  const filterSorting = (parameter: number) => {
    try {
      const searchPerameter = selectOptionsForItems[parameter];
      if (searchPerameter) {
        setSearchKey(searchPerameter.value);
        fetchItems(searchPerameter.value);
        toast.loading(`Sorting by ${searchPerameter.name}, Please wait...`, {
          duration: 2000,
        });
      }
    } catch (err) {}
  };

  useInputSearch({ filterSorting });

  const componentRef = useRef<React.ReactElement | null>();

  return (
    <SearchableContent className={searchKey}>
      <Box>
        <Box
          display="flex"
          alignItems={{ xs: "stretch", md: "center" }}
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          marginBottom={{ xs: "20px", md: "0px" }}
        >
          <Box>
            <Typography variant="h3" component="h3" gutterBottom>
              Item Stock
            </Typography>
            <Typography variant="subtitle2">All Items stock</Typography>
          </Box>
          <PrintButton componentRef={componentRef} />
        </Box>

        <SearchPlaces
          hideSearch={false}
          FieldName="Search item name, code..."
          selectOptions={selectOptionsForItems}
          setSearchKey={setSearchKey}
          searchKey={searchKey}
          search={search}
          setSearch={setSearch}
        />
        <Box ref={componentRef} sx={{ overflow: "auto", position: "relative" }}>
          {loading && (
            <div className="loading-overlay">
              <CircularProgress />
            </div>
          )}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {Object.keys(ProductTableHeading).map((heading) => {
                    return (
                      <TableCell
                        align={ProductTableHeading[heading].align}
                        key={heading}
                        className={heading}
                      >
                        {heading}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {products?.items?.map((item: Product) => {
                  return (
                    <TableRow
                      style={{ cursor: "pointer", textDecoration: "none" }}
                      component={NavLink}
                      to={`/items/stock/${item.itemCode}`}
                      key={item.id}
                    >
                      <TableCell
                        style={{ textTransform: "uppercase" }}
                        align="left"
                        className="itemCode"
                      >
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.itemCode}
                        </Typography>
                      </TableCell>
                      <TableCell
                        style={{ textTransform: "uppercase" }}
                        align="left"
                      >
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                          className="name"
                        >
                          {item.name}
                        </Typography>
                      </TableCell>

                      <TableCell align="right">
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.pcsOrBundle.toFixed(2)}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.meterOrSuit.toFixed(2)}
                        </Typography>
                      </TableCell>
                      <TableCell align="right" className="Rate">
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                          className={"Rate"}
                        >
                          {item.unitPurchasePrice.toFixed(2)}{" "}
                        </Typography>
                      </TableCell>

                      <TableCell align="right" className="Amount">
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {formattedNum(
                            item.unitPurchasePrice * item.meterOrSuit,
                          )}
                        </Typography>
                      </TableCell>

                      {/* <TableCell align="center">
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={async () => {
                      const confirm = window.confirm(
                        "Are you sure You want to delete",
                      );
                      if (confirm) {
                        await deleteProductRequest({
                          variables: {
                            deletewithids: {
                              id: [item.id],
                            },
                          },
                        });
                      }
                    }}
                  >
                    <DeleteForever />
                  </IconButton>
                </TableCell> */}
                    </TableRow>
                  );
                })}
                {products?.amount ? (
                  <TableRow
                    className="total_span"
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell
                      style={{ textTransform: "uppercase" }}
                      align="left"
                    ></TableCell>
                    <TableCell
                      style={{ textTransform: "uppercase" }}
                      align="left"
                    ></TableCell>
                    <TableCell
                      style={{ textTransform: "uppercase" }}
                      align="left"
                    ></TableCell>

                    <TableCell align="right">
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        color="text.primary"
                        gutterBottom
                        noWrap
                      >
                        Total
                      </Typography>
                    </TableCell>

                    <TableCell align="right">
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        color="text.primary"
                        gutterBottom
                        noWrap
                      >
                        {products?.amount ? products?.amount?.toFixed(2) : 0}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {/* <Box p={2}>
        <TablePagination
          component="div"
          count={-1}
          onPageChange={(e, number) => {
            setPage(number);
          }}
          page={page}
          onRowsPerPageChange={(e) => setLimit(Number(e.target.value))}
          rowsPerPage={limit}
          rowsPerPageOptions={[15, 30, 50, 100]}
        />
      </Box> */}
      </Box>
    </SearchableContent>
  );
}
// 1407991579;
